'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFetcher$0024$0024anon$00246 from "./presto.-Fetcher$$anon$6.js";
import * as $j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat$0024 from "./presto.-Fetcher$-Unified-Error-Format$.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$$anon$5() {
  this.aSP = null;
  this.aSH = null;
  this.aSI = false;
  this.aSQ = null;
  this.aSR = false;
  this.aSU = null;
  this.aSN = null;
  this.aSO = false;
  this.aSJ = null;
  this.aSK = false;
  this.aSL = null;
  this.aSM = false;
  this.aSS = false;
  this.aST = false;
  this.aSP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aSU = "UnifiedErrorFormat";
}
export { $c_Lpresto_Fetcher$$anon$5 as $c_Lpresto_Fetcher$$anon$5 };
$p = $c_Lpresto_Fetcher$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$$anon$5;
/** @constructor */
function $h_Lpresto_Fetcher$$anon$5() {
}
export { $h_Lpresto_Fetcher$$anon$5 as $h_Lpresto_Fetcher$$anon$5 };
$h_Lpresto_Fetcher$$anon$5.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aSP;
});
$p.L = (function() {
  if ((!this.aSI)) {
    this.aSH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aSI = true;
  }
  return this.aSH;
});
$p.O = (function() {
  if ((!this.aSR)) {
    this.aSQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aSR = true;
  }
  return this.aSQ;
});
$p.E = (function() {
  return this.aSU;
});
$p.t = (function() {
  if ((!this.aSO)) {
    this.aSN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("message", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("status", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("trace", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aSO = true;
  }
  return this.aSN;
});
$p.M = (function() {
  if ((!this.aSK)) {
    this.aSJ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB)), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aSK = true;
  }
  return this.aSJ;
});
$p.Q = (function() {
  if ((!this.aSM)) {
    this.aSL = new $j_presto$002e$002dFetcher$0024$0024anon$00246.$c_Lpresto_Fetcher$$anon$6();
    this.aSM = true;
  }
  return this.aSL;
});
$p.w = (function() {
  if ((!this.aST)) {
    this.aSS = false;
    this.aST = true;
  }
  return this.aSS;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee19) => ((p) => \u03b4scrutinee19.cG8(p)))($j_presto$002e$002dFetcher$0024$002dUnified$002dError$002dFormat$0024.$m_Lpresto_Fetcher$UnifiedErrorFormat$())));
});
var $d_Lpresto_Fetcher$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$$anon$5, "presto.Fetcher$$anon$5", ({
  Iu: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Fetcher$$anon$5 as $d_Lpresto_Fetcher$$anon$5 };
//# sourceMappingURL=presto.-Fetcher$$anon$5.js.map
